import type { GameMeta } from "@kit/meta";

export const meta: GameMeta = {
  id: "zaman",
  name: "Zaman Çizgisi",
  tagline: "Olayları doğru yıllara yerleştir.",
  inspiredBy: "Timeline / Hitster card games",
  secondLayer: "Kronoloji sıralama × tarih bilgisi",
  accent: "#6a4c93",
  status: "lab",
};
